<div class="container">
  <div class="header">
    <div class="left">
      <a routerLink="/" class="header__logo">
        <img class="web" [src]="siteData.headerLogo" alt="logo" />
        <img class="mobile" [src]="siteData.mobileLogo" alt="logo" />
      </a>
    </div>
    <div class="right">
      <div class="header__btn web">
        <a (click)="jobListRedirect()" class="navigation">
          <i class="fa-regular fa-magnifying-glass"></i> Find Job
        </a>
        @if (loginDisplay) {
          <a
            class="navigation"
            routerLink="/candidate-profile"
            >
            About Me
          </a>
        }
        @if (loginDisplay) {
          <a
            nz-dropdown
            nzTrigger="click"
            class="navigation"
            [nzDropdownMenu]="myJobs"
            >
            My Jobs
            <i nz-icon nzType="down"></i>
          </a>
        }
        <nz-dropdown-menu #myJobs="nzDropdownMenu">
          <ul nz-menu class="my-jobs">
            <li nz-menu-item>
              <a routerLink="/saved-jobs" routerLinkActive="active">
                <i class="fa-light fa-heart"></i>Saved Jobs
              </a>
            </li>
            <li nz-menu-item>
              <a routerLink="/applications" routerLinkActive="active">
                <i class="fa-light fa-file-lines"></i>Applications
              </a>
            </li>
            @if (isCloudstaffer) {
              <li nz-menu-item>
                <a routerLink="/referrals" routerLinkActive="active">
                  <i class="fa-light fa-user-group"></i>Referrals
                </a>
              </li>
            }
            @if (isJobAlert) {
              <li nz-menu-item (click)="onJobAlertClicked()">
                <a><i class="fa-light fa-bell"></i>Job Alerts</a>
              </li>
            }
          </ul>
        </nz-dropdown-menu>
        @if (isRegistrationNav && !loginDisplay) {
          <span
            class="registration-text"
            >
          </span>
        }
        @if (!isRegistrationNav && !loginDisplay) {
          <button
            nz-button
            nzType="primary"
            class="btn-signup"
            (click)="showRegistration()"
            >
            {{ siteData.signUp }}
          </button>
        }
        @if (!loginDisplay) {
          <button
            nz-button
            nzType="primary"
            (click)="login()"
            >
            {{ siteData.signIn }}
          </button>
        }
        @if (loginDisplay) {
          <a
            nz-dropdown
            nzTrigger="click"
            class="logged-user"
            [nzDropdownMenu]="loggedMenu"
					[style.background-image]="
						'url(' + getProfilePix(personalInfo.imageUrl) + ')'
					"
            >
          </a>
        }
        <nz-dropdown-menu #loggedMenu="nzDropdownMenu">
          <ul nz-menu class="my-jobs">
            <li nz-menu-item (click)="logout()">
              <a>
                <i class="fa-light fa-arrow-right-from-bracket"></i>Sign out
              </a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
      <div class="header__btn mobile">
        @if (!loginDisplay) {
          <button
            nz-button
            nzType="primary"
            (click)="login()"
            type="button"
            >
            Sign In
          </button>
        }
        <div class="navigation navigation--mobile" (click)="mobileDrawerOpen()">
          <i class="fa-solid fa-bars"></i>
        </div>
      </div>
    </div>
  </div>
</div>

@if(genericData?.modalRegistration){
  <app-registration [isShowRegistration]="genericData?.modalRegistration"
    (hideRegistration)="hideRegistration()"
    (showLoginModal)="showLoginFromRegistration()"
     />
}

<app-registration-more />
<nz-drawer
  [nzClosable]="true"
  [nzVisible]="mobileDrawer"
  nzPlacement="right"
  [nzTitle]="drawerTitle"
  (nzOnClose)="mobileDrawerClose()"
  [nzFooter]="drawerFooter"
  nzWrapClassName="drawer-login"
  >
  <ng-template #drawerTitle>
    <img class="logo" [src]="siteData.mobileLogo" alt="" />
  </ng-template>
  <ng-container *nzDrawerContent>
    @if (!isRegistrationNav && !loginDisplay) {
      <button
        nz-button
        nzType="primary"
        class="btn-signup"
        (click)="showRegistration()"
        >
        Sign Up
      </button>
    }
    @if (!loginDisplay) {
      <button nz-button nzType="primary" (click)="login()">
        Sign In
      </button>
    }
    @if (!loginDisplay) {
      <a (click)="jobListRedirect()" class="nav-btn">
        <i class="fa-regular fa-magnifying-glass"></i> Find Job
      </a>
    }

    @if (loginDisplay) {
      <div class="mobile-drawer">
        <a routerLink="/candidate-profile" (click)="closeDrawer()">
          <div
            class="cs-profile dropdown-toggle"
					[style.background-image]="
						'url(' + getProfilePix(personalInfo.imageUrl) + ')'
					"
          ></div>
          About Me
        </a>
        <ul>
          <li (click)="jobListRedirect()">
            <i class="fa-regular fa-magnifying-glass"></i> Find Job
          </li>
          <li>
            <i class="fa-light fa-briefcase"></i> My Jobs
            <ul>
              <li>
                <a routerLink="/saved-jobs" (click)="closeDrawer()">
                  <i class="fa-light fa-heart"></i> Saved Jobs
                </a>
              </li>
              <li>
                <a routerLink="/applications" (click)="closeDrawer()">
                  <i class="fa-light fa-file-lines"></i> Applications
                </a>
              </li>
              @if (isCloudstaffer) {
                <li>
                  <a routerLink="/referrals" (click)="closeDrawer()">
                    <i class="fa-light fa-user-group"></i> Referrals
                  </a>
                </li>
              }
              <li (click)="onJobAlertClicked()">
                <a><i class="fa-light fa-bell"></i>Job Alerts</a>
              </li>
            </ul>
          </li>
          <li (click)="logout()">
            <i class="fa-light fa-arrow-right-from-bracket"></i> Sign out
          </li>
        </ul>
      </div>
    }
  </ng-container>
  <ng-template #drawerFooter />
</nz-drawer>

<nz-modal
  [(nzVisible)]="showChangePassword"
  (nzOnCancel)="closeChangePassword()"
  (nzOnOk)="saveChangePassword()"
  nzWrapClassName="login-modal"
  [nzContent]="modalContent"
  nzKeyboard="false"
  >
  <ng-template #modalContent>
    <div class="content-holder">
      <h1 class="modal-header">Change password</h1>
      <ng-container [formGroup]="changePasswordForm">
        <div
          class="nz-block-input"
					[ngClass]="
						changePasswordForm.controls['currentPassword'].status ===
							'INVALID' &&
						changePasswordForm.controls['currentPassword'].touched
							? 'error'
							: ''
					"
          >
          <label>Current password</label>
          <nz-input-group [nzSuffix]="suffixIconSearch1">
            <input
              nz-input
              formControlName="currentPassword"
              type="password"
              placeholder="Current password"
              nzSize="large"
              [type]="showCurrentPassword ? 'text' : 'password'"
              />
            </nz-input-group>

            <ng-template #suffixIconSearch1>
              <div (click)="showCurrentPassword = !showCurrentPassword">
                @if (showCurrentPassword) {
                  <i class="fa-regular fa-eye"></i>
                }
                @if (!showCurrentPassword) {
                  <i
                    class="fa-regular fa-eye-slash"
                  ></i>
                }
              </div>
            </ng-template>
          </div>

          <div
            class="nz-block-input"
					[ngClass]="
						changePasswordForm.controls['newPassword'].status === 'INVALID' &&
						changePasswordForm.controls['newPassword'].touched
							? 'error'
							: ''
					"
            >
            <label>Enter new password</label>
            <nz-input-group [nzSuffix]="suffixIconSearch2">
              <input
                nz-input
                formControlName="newPassword"
                type="password"
                placeholder="New password"
                nzSize="large"
                [type]="showNewPassword ? 'text' : 'password'"
                />
              </nz-input-group>

              <ng-template #suffixIconSearch2>
                <div (click)="showNewPassword = !showNewPassword">
                  @if (showNewPassword) {
                    <i class="fa-regular fa-eye"></i>
                  }
                  @if (!showNewPassword) {
                    <i class="fa-regular fa-eye-slash"></i>
                  }
                </div>
              </ng-template>
            </div>
            @if (
              changePasswordForm.controls['newPassword'].status === 'INVALID' &&
              changePasswordForm.controls['newPassword'].touched
              ) {
              <div
                class="error-holder"
					[ngClass]="{
						error:
							changePasswordForm.controls['newPassword'].status === 'INVALID' &&
							changePasswordForm.controls['newPassword'].touched
					}"
                >
                <h1>Password must contain:</h1>
                <div
                  class="message"
						[ngClass]="{
							error: changePasswordForm.value.newPassword?.match('.{8,}')
						}"
                  >
                  <i class="fa-light fa-check"></i>
                  <i class="fa-light fa-xmark"></i>
                  At least 8 characters
                </div>
                <div
                  class="message"
						[ngClass]="{
							error:
								changePasswordForm.value.newPassword?.match('^(?=.*[A-Z])') &&
								changePasswordForm.value.newPassword?.match('(?=.*[a-z])')
						}"
                  >
                  <i class="fa-light fa-check"></i>
                  <i class="fa-light fa-xmark"></i>
                  both lower (a-z) and upper case letters (A-Z)
                </div>
                <div
                  class="message"
						[ngClass]="{
							error:
								changePasswordForm.value.newPassword?.match('^(?=.*[0-9])') &&
								changePasswordForm.value.newPassword?.match('(?=.*[!@#$%^&*])')
						}"
                  >
                  <i class="fa-light fa-check"></i>
                  <i class="fa-light fa-xmark"></i>
                  at least one number (0-9) and a symbol
                </div>
              </div>
            }

            <div
              class="nz-block-input"
					[ngClass]="
						changePasswordForm.controls['confirmPassword'].status ===
							'INVALID' &&
						changePasswordForm.controls['confirmPassword'].touched
							? 'error'
							: ''
					"
              >
              <label>Confirm password</label>
              <nz-input-group [nzSuffix]="suffixIconSearch3">
                <input
                  nz-input
                  formControlName="confirmPassword"
                  type="password"
                  placeholder="Confirm password"
                  nzSize="large"
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  />
                </nz-input-group>

                <ng-template #suffixIconSearch3>
                  <div (click)="showConfirmPassword = !showConfirmPassword">
                    @if (showConfirmPassword) {
                      <i class="fa-regular fa-eye"></i>
                    }
                    @if (!showConfirmPassword) {
                      <i
                        class="fa-regular fa-eye-slash"
                      ></i>
                    }
                  </div>
                </ng-template>
              </div>
              @if (!isPasswordSame) {
                <div class="error-holder">
                  <div class="message">
                    <i class="fa-light fa-xmark"></i> New Password and Confrim Password
                    must be same!
                  </div>
                </div>
              }
              <div style="margin-top: 25px">
                <button
                  nz-button
                  class="btn-next"
                  nzType="primary"
                  nzSize="large"
                  nzShape="round"
                  (click)="saveChangePassword()"
                  >
                  Save
                </button>
                <button
                  nz-button
                  style="margin-left: 10px"
                  nzType="default"
                  nzSize="large"
                  nzShape="round"
                  (click)="closeChangePassword()"
                  >
                  Cancel
                </button>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </nz-modal>

      <nz-modal
        [(nzVisible)]="isRegisteredCheckerVisible"
        (nzOnCancel)="closeRegisteredCheckerVisible()"
        nzCentered
        nzWrapClassName="login-modal"
        nzWidth="600px"
        nzMaskClosable="false"
        nzKeyboard="false"
        >
        <ng-container *nzModalContent>
          <div class="content-holder is-account-exist-modal">
            <!-- <h1 class="modal-header">Invite your friends</h1> -->
            <img src="assets/images/verify-account.png" alt="image" />
            <label>
              It looks like you don't have a Cloudstaff Jobs account yet.
            </label>
            <label> Create one to get started! </label>
            <p>
              Create your Cloudstaff Careers account and we will help you find your
              dream career.
            </p>
            <br />
            <button
              nz-button
              class="btn-next"
              nzType="primary"
              nzSize="large"
              nzShape="round"
              (click)="showRegistration()"
              >
              Sign Up
            </button>
          </div>
        </ng-container>
      </nz-modal>

      @if (isJobAlertModal) {
        <app-job-alert [isVisible]="isJobAlertModal"
          (modalEvent)="jobAlertModalEvent($event)"
         />
      }

      <app-qr-referral [showQRModal]="showQRModal"
        (showRegistration)="showRegistration()"
       />
